import * as React from "react"

export const VisibilityIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="20"
    height="20"
    fill="none"
    viewBox="0 0 20 20"
    {...props}
  >
    <path
      fill="currentColor"
      d="M10.002 13.148c.875 0 1.618-.306 2.229-.919.611-.612.917-1.356.917-2.23 0-.875-.307-1.618-.919-2.23-.612-.61-1.356-.916-2.23-.916-.876 0-1.619.306-2.23.918-.61.613-.916 1.356-.916 2.231 0 .875.306 1.618.918 2.23.612.61 1.356.916 2.23.916ZM10 12a1.929 1.929 0 0 1-1.417-.583A1.929 1.929 0 0 1 8 10c0-.555.194-1.027.583-1.416A1.929 1.929 0 0 1 10 8c.556 0 1.028.195 1.417.584.389.389.583.86.583 1.416 0 .556-.194 1.028-.583 1.417A1.929 1.929 0 0 1 10 12Zm0 3.584a8.66 8.66 0 0 1-4.699-1.352 10.349 10.349 0 0 1-3.452-3.558.99.99 0 0 1-.141-.326 1.561 1.561 0 0 1 0-.69.985.985 0 0 1 .141-.33 10.349 10.349 0 0 1 3.452-3.56A8.659 8.659 0 0 1 10 4.418a8.66 8.66 0 0 1 4.699 1.352 10.35 10.35 0 0 1 3.452 3.558.99.99 0 0 1 .142.326 1.561 1.561 0 0 1 0 .69.986.986 0 0 1-.142.33 10.35 10.35 0 0 1-3.452 3.559A8.66 8.66 0 0 1 10 15.584Zm0-1.084a8.123 8.123 0 0 0 4.313-1.208A8.085 8.085 0 0 0 17.354 10a8.084 8.084 0 0 0-3.041-3.291A8.122 8.122 0 0 0 10 5.5 8.123 8.123 0 0 0 5.688 6.71 8.085 8.085 0 0 0 2.646 10a8.085 8.085 0 0 0 3.042 3.292A8.123 8.123 0 0 0 10 14.5Z"
    />
  </svg>
)
